import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

import { getAuthDeveloper, isLoggedIn } from "../../helpers/authHelper";
import { AppStore } from "../../redux/store";
import NavBarLandlord from "./NavBarLandlord";
import NavBarTenant from "./NavBarTenant";
import NavBarMobile from "./NavBarMobile";
import useIsVisibleComponent from "../../hooks/useIsVisibleComponent";


import logo from "../../assets/images/logo_propi.svg";
import logoWhite from "../../assets/images/logo_propi_white.svg";
import hamburger from "../../assets/icons/hamburger.svg";
import hamburger_white from "../../assets/icons/hamburger-white.svg";
import { toogleAction } from "../../redux/features/navigation";

import "./scss/NavBar.scss";
import { DEFAULT_AVATAR } from "../../constants/ProfileConstants";
import NavBarInvestor from './NavBarInvestor';
import OptionDev from "./OptionDev";
import { loginActionDeveloper } from "../../redux/features/authDeveloper";
import { AuthDeveloper } from "../../models/authUserModel";

type Props = {
  children?: JSX.Element;
};

const NavBarDev = ({ children }: Props) => {
  const { country } = useSelector((store: AppStore) => store.country);
  const dev = useSelector((store: AppStore) => store.authDeveloper);
  const user = useSelector((store: AppStore) => store.auth);
  const { visible: showNav } = useSelector(
    (store: AppStore) => store.navigation
  );
  const authDevStorage = getAuthDeveloper();
  const [showModal, setShowModal] = useState<boolean>(true);
  const dispatch = useDispatch();
  const [showMobile, setShowMobile] = useState(false);
  const isLogged = isLoggedIn(user);
  const navigate = useNavigate();
  const location = useLocation();
  const [navbar, setNavbar] = useState(false);
  const [navbarLogo, setNavbarLogo] = useState(logo);
  const { ref } = useIsVisibleComponent();
  const [authData, setAuthData] = useState<AuthDeveloper>({
    company_logo: '',
    company_name: '',
    company_role: ''
  })

  const LogoWhite = () => {
    if (location.pathname === "/" && window.scrollY <= 66) {
      setNavbarLogo(logoWhite);
    } else {
      setNavbarLogo(logo);
    }
  };
  const changeBackground = () => {
    if (location.pathname === "/" && window.scrollY <= 66) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  useEffect(() => {
    changeBackground();
    // adding the event when scroll change background
    window.addEventListener("scroll", changeBackground);
  });

  useEffect(() => {
    LogoWhite();
    // adding the event when scroll change Logo
    window.addEventListener("scroll", LogoWhite);
  });

  const doShowNav = () => {
    if (isLogged) {
      dispatch(toogleAction(!showNav));
    } else {
      return navigate(`/app/${country}/auth/login`);
    }
  };

  const getNavBar = () => {
    if (!showNav || !isLogged) {
      return null;
    }
    switch (user.realm) {
      case 'landlord':
        return <NavBarLandlord />
      case 'tenant':
        return <NavBarTenant />
      case 'investor':
        return <NavBarInvestor />
    case 'developer':
        return <OptionDev />
    }
  };

  const toggleMobile = () => {
    try {
      setShowMobile((old) => !old);
      document.body.style.overflow = "scroll";
    } catch (error) {}
  };

  useEffect(() => {
    const authDevStorage = getAuthDeveloper();
    if (authDevStorage) {
      const authData = JSON.parse(authDevStorage);
      setAuthData(authData)
    }
  }, [])


  return (
    <div ref={ref}>
      <nav
        className={
          navbar
            ? "normal bg-transparent px-2 sm:px-4 py-2.5 fixed top-0 w-full z-50"
            : "active bg-white px-2 sm:px-4 pt-2.5 fixed top-0 w-full z-50"
        }
      >
        <div className="container mx-auto flex justify-between items-center mb-3">
          <div className="flex items-center justify-start gap-3">
          <a href="/" className="flex items-center w-auto">
            <img src={'https://storage.googleapis.com/assets-us-east4-propilatam/website-assets/propi-web/v2/logo-propi.svg'} className="mr-3 h-6 sm:h-9" alt="Logo" />
          </a>
          {user?.realm_roles[0] === "developer_bank_dashboard" ? (
            <div className="hidden lg:flex items-center justify-start text-[#616161]">
              | <p className="text-xs lg:text-sm text-[#757575] ml-4">Institución financiera:</p>
                <img className="ml-3 h-6 sm:h-10" src={authData?.company_logo} alt="logo bank" />
                <img className="ml-3 h-6 sm:h-10" src="https://storage.googleapis.com/assets-us-east4-propilatam/website-assets/propi-web/invest/apc.png" alt="logo bank" />
            </div>
              
        
          ) : (
            <></>
          )}
          </div>
         
          <div
            className="justify-between items-center flex w-auto md:order-1 relative"
            id="mobile-menu-4"
          >
            <div className="flex">
              <button
                onClick={doShowNav}
                type="button"
                className={`${user.realm === 'investor' ? 'bg-blueForm' : 'bg-gray-900 '}
                  pl-2 pr-4 w-auto text-sm py-1 text-white font-normal rounded-full flex justify-start items-center group`}
              >
                <img
                  className="rounded-full w-7 h-7"
                  src={isLogged && user.avatar ? user.avatar : DEFAULT_AVATAR}
                  alt=""
                />
                <span className="ml-4">
                  {isLogged ? "Mi Cuenta" : "Iniciar sesión"}
                </span>
              </button>
              <div>{getNavBar()}</div>
            </div>
          </div>
         
        </div>
        {children}
      </nav>
      {showMobile && <NavBarMobile onAction={toggleMobile} />}
      
      
    </div>
  );
};

export default NavBarDev;
